<template>
  <transition name="p-act__pl">
  <div class="p-act__pl" v-if="max > 0">
    <div class="p-act__midTitle">
      <div class="p-act__midTitle__wrap">
        <h2 v-if="type === 'celebrity'"><span>I LADY.</span>を応援する人たち</h2>
        <h2 v-else-if="type === 'activist'"><span>ACTIVISTS</span></h2>
      </div>
    </div>
    <div class="p-act__plList">
      <ul>
        <li v-for="(p, i) in params">
          <a v-if="p.insta" class="c-person" :href="p.insta" target="_blank" rel="noopener">
            <div class="c-personPhoto">
              <img :src="p.img" alt="" width="240" height="240" />
              <div
                v-if="p.label"
                class="c-personPhoto__label"
                :class="{'c-personPhoto__label--w100':p.label==='PEER ACTIVISTS'}"
              >{{p.label}}</div>
            </div>
            <div class="c-personInfo">
              <p>{{p.title}}</p>
              <h3 :class="{'c-personInfo__insta': p.insta}">{{p.name}}</h3>
            </div>
          </a>
          <div v-else class="c-person">
            <div class="c-personPhoto">
              <img :src="p.img" alt="" width="240" height="240" />
              <div
                v-if="p.label"
                class="c-personPhoto__label"
                :class="{'c-personPhoto__label--w100':p.label==='PEER ACTIVISTS'}"
              >{{p.label}}</div>
            </div>
            <div class="c-personInfo">
              <p>{{p.title}}</p>
              <h3 :class="{'c-personInfo__insta': p.insta}">{{p.name}}</h3>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div v-if="!isFinish" class="p-act__plMore">
      <div class="c-btnLink c-btnLink--more" @click="more">
        <span class="c-btnLink__text">MORE</span>
        <span class="c-btnLink__arrowD"></span>
        <span class="c-btnLink__line"></span>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    props: ['type', 'step'],
    data() {
      return {
        assets_path: assets_path,
        params: [],
        data: [],
        max: 0,
        count: 0,
        //step: 10,
        isFinish: false
      }
    },
    store,
    mounted() {
      this.data = JSON.parse(document.getElementById(`js-param-${this.type}`).textContent);
      this.max = this.data.length;

      if (!this.step) {
        this.step = 2;
      }

      this.add();
    },
    methods: {
      add() {
        const arr = this.data.splice(0, this.step);
        const start = this.params.length;
        const step = Math.min(arr.length, this.step);

        for (let i = 0; i < step; i++) {
          this.$set(this.params, start + i, arr[i]);
        }

        if (this.data.length === 0) {
          this.isFinish = true;
        }
      },
      more() {
        if (this.isFinish) return;
        this.add();
      }
    }
  }
</script>
